import React from "react";

// import components
import DCard from "./DCard";
import { Heading, Skeleton } from "@chakra-ui/react";
const DashboardAnalysisCards = ({ data }) => {
    return (
        <div className="grid mb-4 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            {data.map(d => (
                <DCard key={d.id}>
                    <div className="flex justify-between">
                        <Heading as="h2" size={["sm", "sm", "md"]}>
                            {d.name}
                        </Heading>
                        <div className="flex shrink-0 items-center justify-center w-[40px] h-[40px] text-xl bg-primary-color-500 text-white rounded-full">
                            {d.icon}
                        </div>
                    </div>
                    {d.loading ? (
                        <Skeleton className="h-[30px] w-1/4"></Skeleton>
                    ) : (
                        <Heading as="h2" size="xl">
                            {d.total || 0}
                        </Heading>
                    )}
                </DCard>
            ))}
        </div>
    );
};

export default DashboardAnalysisCards;
